import { ReactComponent as AddAdminSvg } from "../../assets/images/svgs/addAdmin.svg";

const AddAdminIcon = ({ className = "", ...props }) => {
  return (
    <AddAdminSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default AddAdminIcon;
